import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UnlockSlideBtn, GlassBtn } from "../../buttons";
import "./financeReportingLogin.scss";

const INVESTOR_WHITELIST = [
  "alice@skitsicon.com",
  "bob@skitsicon.com",
  "carol@skitsicon.com",
];
const CFO_WHITELIST = ["lowlow@skitsicon.com"];

export default function FinanceLogin() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const val = e.target.value;
    setEmail(val);
    if (error) setError("");

    // persist the raw email as soon as they type:
    localStorage.setItem("financeUser", val.trim().toLowerCase());
  };

  const handleSubmit = () => {
    const candidate = email.trim().toLowerCase();
    if (!candidate) {
      setError("Please enter your email.");
      return;
    }

    const isCfo = CFO_WHITELIST.includes(candidate);
    const isInvestor = INVESTOR_WHITELIST.includes(candidate);

    if (isCfo || isInvestor) {
      // persist their role now that we know it
      localStorage.setItem("financeRole", isCfo ? "cfo" : "investor");

      // navigate
      return navigate(isCfo ? "/reports/cfo" : "/reports/investor", {
        replace: true,
      });
    }

    setError("Unauthorized user.");
  };

  return (
    <div id="finance">
      <div className="formWrapper">
        <h2 className="financeHeader">Finance Login</h2>
        <div className="finance-input-group blinker-wrapper">
          <input
            id="finance-email"
            type="email"
            value={email}
            onChange={handleChange}
            placeholder="you@skitsicon.com"
          />
          <span className="blinking-cursor-gold-color finance-cursor">|</span>
        </div>
        {error && <div className="error">{error}</div>}

        <UnlockSlideBtn
          onHandleSlideEnd={handleSubmit}
          slideBtnText="Slide right to log in"
          slideBtnFontColor="#000"
          slideBtnFontWeight="800"
          slideBtnWidth="100%"
          slideBtnheight="35px"
          marginTop="10px"
          slideBtnLeft="0"
          slideBtTop="5px"
        />
        <div className="icon-seporator">
          <div className="or-and bar-horizontal icon-vertical">
            <span>OR</span>
          </div>
        </div>
        <GlassBtn
          glassBtnText="← Back to Landing Page"
          glassBtnHeight="20px"
          glassBtnWidth="fit-content"
          sparkle="true"
          glassBtnMarginTop="30px"
          onClick={() => {
            localStorage.clear();
            navigate("/", { replace: true });
          }}
          hi2Style={{
            transform: "rotate(90deg) translate(-30px, 100px)",
          }}
          hi3Style={{
            transform: "rotate(90deg) translate( -30px, -100px)",
          }}
        />
      </div>
    </div>
  );
}
